import { configureStore } from '@reduxjs/toolkit';
import cartReducer from './cartSlice';
import authReducer from './authSlice';

let preloadedCart;
try {
  const saved = localStorage.getItem('cart_state');
  if (saved) preloadedCart = JSON.parse(saved);
} catch { /* ignore */ }

const store = configureStore({
  reducer: {
    cart: cartReducer,
    auth: authReducer,
  },
  preloadedState: preloadedCart ? { cart: preloadedCart } : undefined,
});

store.subscribe(() => {
  const { cart } = store.getState();
  localStorage.setItem('cart_state', JSON.stringify(cart));
});

export default store;
